import { CoreActivityFormModel, CoreActivityItemModel, CoreActivitySummaryItemModel, YesNoEnumDesc } from '../../api/models';
import { map } from 'lodash';

const applicationActivityType = (values: CoreActivityFormModel) => values && values.applicationActivityType ? [...values.applicationActivityType] : [];

const createDefaultItem = (values: CoreActivityFormModel): Partial<CoreActivityItemModel> => {
    return {
        ...values,
        id: 0,
        organisationMecType: values.organisationMecType,
        referenceNumber: undefined,
        projects: values.projects ? [...values.projects] : [],
        levyCollectingRspItems: values.levyCollectingRspItems,
        rspNonLevyItems: values.rspNonLevyItems,
        crcItems: values.crcItems,
        afiRnDEntityABN: values.afiRnDEntityABN,
        organisationUhcAbn: values.organisationUhcAbn,
        primaryTaxAgentAbn: values.primaryTaxAgentAbn,
        applicationActivityType: applicationActivityType(values),
        incomePeriodDateRange: {
            ...values.incomePeriodDateRange,
        },
        financialYear1: getFinancialYear(values.financialYear, 0),
        financialYear2: getFinancialYear(values.financialYear, 1),
        financialYear3: getFinancialYear(values.financialYear, 2),

        allOtherActivitiesForThisApp: [],
        availableCrcs: values.availableCrcs,
        availableLevyRsps: values.availableLevyRsps,
        availableNonLevyRsps: values.availableNonLevyRsps,
        isToListPreviousCoreActivity: undefined,                        /* Q.61   */
        name: '',                                                       /* Q.62   */
        describeCoreActivity: '',                                       /* Q.63   */
        projectId: undefined,                                           /* Q.64   */
        isActivityExcludedFromCore: undefined,                          /* Q.65   */
        activitiesPerformedBy: undefined,                               /* Q.66   */
        companyName: '',                                                /* Q.67   */
        isEntityConductingActivityConnectedOrAffiliated: undefined,     /* Q.68   */
        isActivityRnDEntityLocatedOutsideAustralia: undefined,          /* Q.69   */
        activityConductedBy: undefined,                                 /* Q.70   */
        subsidiaryConductAbn: undefined,                                /* Q.71   */
        companyCountryOfResidence: undefined,                           /* Q.72   */
        futureCoreActivity: undefined,                                  /* Q.73   */
        duration: {                                                     /* Q.74   */
            endMonth: undefined,
            endYear: undefined,
            startMonth: undefined,
            startYear: undefined,
        },
        otherOrganisation: 'No',                                        /* Q.75   */
        isActivityCoveredByIRDD: undefined,                             /* Q.76   */
        determinationRelyingOn: '',                                     /* Q.77   */
        outcome: [],                                                    /* Q.78   */
        sourcesInvestigated: '',                                        /* Q.79   */
        competentProfesionalReason: '',                                 /* Q.80   */
        whyNoInvestigation: '',                                         /* Q.81   */
        hypothesis: '',                                                 /* Q.82   */
        experiment: '',                                                 /* Q.83   */
        evaluation: '',                                                 /* Q.84   */
        conclusions: '',                                                /* Q.85   */
        evidenceAvailable: [],                                          /* Q.86   */
        evidenceAvailableOther: '',                                     /* Q.87   */
        purpose: undefined,                                             /* Q.88   */
        newKnowledge: '',                                               /* Q.89   */
        otherOrganisationName: '',                                      /* Q.90   | Q.91   */
        briefDescription: '',                                           /* Q.90.1 | Q.91.1 */
        expenditure: undefined,                                         /* Q.92   */
        expenditurePriorToYear1: undefined,                             /* Q.93.1 */
        financialYear1EstimatedExpenditure: undefined,                  /* Q.93.2 */
        financialYear2EstimatedExpenditure: undefined,                  /* Q.93.3 */
        financialYear3EstimatedExpenditure: undefined,                  /* Q.93.4 */
        financialYear3EstimatedExpenditurePost: undefined,              /* Q.93.5 */
    };
};

const getFinancialYear = (financialYear: string | null, increment: number): string => {
    if (!financialYear) {
        return '';
    }

    const startFinancialYear = financialYear.substring(0, 4);
    const endFinancialYear = financialYear.substring(5);

    const startYear = parseInt(startFinancialYear, 10) + increment;
    const endYear = parseInt(endFinancialYear, 10) + increment;

    return `${startYear}/${endYear.toString().slice(-2)}`;
};

const getAllOtherCoreActivities = (values: CoreActivityFormModel): Partial<string>[] => {
    return map(values.items, i => {
        return i.name!;
    });
};

export const coreActivityDetailsItem = (values: CoreActivityFormModel): Partial<CoreActivityItemModel> => {
    return {
        ...createDefaultItem(values),
        allOtherActivitiesForThisApp: getAllOtherCoreActivities(values),
    };
};

export const coreActivitySummaryItem = (_values: CoreActivityFormModel): Partial<CoreActivitySummaryItemModel> => {
    return {
        referenceNumber: ' ',
        end: ' ',
        id: 0,
        issues: undefined,
        name: ' ',
        start: ' ',
    };
};
